
import { ShoppingCart, Users, Warehouse } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const SaleTypesExplanation = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-muted/30 to-background">
      <div className="container">
        <h2 className="text-3xl font-bold text-center mb-4">אז איך תקנו?</h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          באתר שלנו תמצאו שלושה סוגי מכירות שונים, כל אחד עם יתרונות ייחודיים. הכירו את ההבדלים ובחרו את המתאים לכם.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Regular Sale Card */}
          <Card className="border-2 border-blue-500 hover:border-blue-400 transition-colors shadow-lg">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
                <ShoppingCart className="w-8 h-8 text-blue-600" />
              </div>
              <CardTitle className="text-xl">מכירה רגילה</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3 text-sm font-medium">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>קנה עכשיו, קבל עכשיו - ללא המתנה</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>תשלום מיידי ואספקה מהירה</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>מלאי זמין לפי מה שמוצג</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>אפשרות למשלוח או איסוף עצמי</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* Group Buy Card */}
          <Card className="border-2 border-orange-500 hover:border-orange-400 transition-colors shadow-lg">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
                <Users className="w-8 h-8 text-orange-600" />
              </div>
              <CardTitle className="text-xl">קבוצת רכישה</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3 text-sm font-medium">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>משלמים עכשיו, מקבלים אחרי הגעה ליעד</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>מחיר מוזל בזכות רכישה קבוצתית</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>החזר מלא אם לא נגיע ליעד</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>הזמנה מיוחדת - לא ניתן להחזיר את המוצרים</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>אספקה: 30-60 ימים לאחר הגעה ליעד</span>
                </li>
              </ul>
              <div className="mt-4 p-3 bg-orange-50 rounded text-xs text-orange-900">
                <strong>מתי מתאים?</strong> כשמוכנים לחכות קצת ולחסוך כסף
              </div>
            </CardContent>
          </Card>

          {/* Liquidation Card */}
          <Card className="border-2 border-red-500 hover:border-red-400 transition-colors shadow-lg">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-red-50 flex items-center justify-center">
                <Warehouse className="w-8 h-8 text-red-600" />
              </div>
              <CardTitle className="text-xl">חיסול מלאי</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3 text-sm font-medium">
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>מחיר נמוך מאוד - פחות ממחיר יבואן!</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>עוזרים לפנות מלאי ולתרום לסביבה</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>משלוח רק אחרי הגעה ליעד מכירות</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>החזר מלא אם לא נגיע ליעד עד המועד</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-600 mt-0.5">✓</span>
                  <span>לא ניתן להחזיר את המוצרים</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground">
            💡 <strong>טיפ:</strong> כל המוצרים מסומנים בבירור בסוג המכירה. חפשו את התגים בעמודי המוצרים.
          </p>
        </div>
      </div>
    </section>
  );
};
